import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const classicSoftwareBoardRoute: InvariantJiraRoute = {
	name: 'rapidboard-board',
	path: '/jira/software/c/projects/:projectKey/boards/:boardId',
};
